import {YalwaButtonBase} from './button_base.js';

export class YalwaLinkButton extends YalwaButtonBase {
	
	static get observedAttributes() {
		// Inherit base attributes and add link-specific ones
		return [...super.observedAttributes, 'href', 'target', 'rel'];
	}
	
	constructor() {
		super();
		this.initialize_template();
	}
	
	initialize_template() {
		// Only create the template if the shadow root is empty.
		// If DSD was used, the shadow root will already have children.
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = `
				<a class="button" part="button">
					 <slot name="icon_left" part="icon_left"></slot>
					 <slot part="label"></slot>
					 <slot name="icon_right" part="icon_right"></slot>
				</a>
		   `;
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.core_element = this.shadowRoot.querySelector('a');
		if (this.hasAttribute('autofocus')) {
			this.core_element.setAttribute('autofocus', '');
		}
	}
	
	render() {
		super.render();
		const $link = jQuery(this.core_element);
		
		if (this.disabled) {
			// For links, "disabled" means removing the href
			$link.removeAttr('href');
		} else {
			$link.attr('href', this.getAttribute('href'));
		}
		
		if (this.getAttribute('target')) {
			$link.attr('target', this.getAttribute('target'));
		}
		if (this.getAttribute('rel')) {
			$link.attr('rel', this.getAttribute('rel'));
		}
	}
	
	get href() {
		return this.getAttribute('href');
	}
	
	set href(value) {
		this.setAttribute('href', value);
	}
	
	get target() {
		return this.getAttribute('target');
	}
	
	set target(value) {
		this.setAttribute('target', value);
	}
	
	get rel() {
		return this.getAttribute('rel');
	}
	
	set rel(value) {
		this.setAttribute('rel', value);
	}
}

customElements.define('yalwa-link-button', YalwaLinkButton);
